import { defineMessages } from 'react-intl';

const translations = {
  title: {
    id: 'checkParcelsDialog.title',
    defaultMessage: 'Check parcels',
    description: 'Title of the check parcels dialog',
  },
  emptyMessage: {
    id: 'checkParcelsDialog.emptyMessage',
    defaultMessage: 'No parcels',
    description: 'Empty message of the check parcels dialog',
  },
  numberOfItems: {
    id: 'checkParcelsDialog.numberOfItems',
    defaultMessage: 'Number of items: {count}',
    description: 'Number of items text of the check parcels dialog',
  },
  numberOfParcels: {
    id: 'checkParcelsDialog.numberOfParcels',
    defaultMessage: 'Number of parcels: {count}',
    description: 'Number of parcels text of the check parcels dialog',
  },
  buttons: {
    continue: {
      id: 'actions.continue',
      defaultMessage: 'Continue',
      description: 'Label of the continue button in the check parcels dialog',
    },
    newParcel: {
      id: 'actions.newParcel',
      defaultMessage: 'New parcel',
      description: 'Label of the new parcel button in the check parcels dialog',
    },
  },
};

export default defineMessages(translations);
